/**
 * 再認証 (AAL2) が必要なことを表すエラー。
 * `@SecureApi` の 401 + code を handleAuthErrorResponse が throw し、
 * handleApiErrorWithReauth が捕捉して再認証→再実行する。
 */
export class ReauthRequiredError extends Error {
  constructor(readonly displayMessage?: string) {
    super('Reauthentication required');
    this.name = 'ReauthRequiredError';
    Object.setPrototypeOf(this, ReauthRequiredError.prototype);
  }
}
